<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <h1 class="bani-title">
            {{ activeLanguageTranslations?.bibliographyLabel  | translate }}
          </h1>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <!-- <div class="static-content-heading-wrapper">
          {{ activeLanguageTranslations?.bibliographyLabel }}
        </div> -->
     
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography1 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography2 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography3 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography4 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography5 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography6 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography7 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography8 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography9 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography10 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography11 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography12 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography13 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography14 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography15 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography16 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography17 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography18 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography19 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography20 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography21 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography22 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography23 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography24 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography25 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography26 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography27 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography28 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography29 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography30 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography31 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography32 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography33 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography34 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography35 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography36 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography37 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography38 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography39 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography40 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography41 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography42 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography43 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography44 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography45 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography46 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography47 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography48 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography49 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography50 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography51 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography52 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography53 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography54 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography55 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography56 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography57 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography58 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography59 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography60 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography61 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography62 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography63 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography64 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography65 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography66 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography67 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography68 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography69 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography70 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography71 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography72 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography73 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography74 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography75 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography76 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography77 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography78 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography79 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography80 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography81 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography82 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography83 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography84 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography85 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography86 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography87 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography88 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography89 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography90 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography91 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography92 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography93 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography94 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography95 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography96 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography97 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography98 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography99 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography100 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography101 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography102 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography103 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography104 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography105 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography106 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography107 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography108 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography109 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography110 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography111 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography112 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography113 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography114 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography115 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography116 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography117 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography118 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography119 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography120 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography121 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography122 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography123 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography124 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography125 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography126 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography127 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography128 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography129 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography130 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography131 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography132 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography133 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography134 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography135 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography136 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography137 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography138 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography139 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography140 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography141 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography142 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography143 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography144 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography145 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography146 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography147 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography148 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography149 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography150 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography151 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography152 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography153 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography154 }}
        </div>

        <!-- <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography155 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography156 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography157 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography158 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography159 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography160 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography161 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography162 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography163 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography164 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography165 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography166 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography167 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography168 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography169 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography170 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography171 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography172 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography173 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography174 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography175 }}
        </div>

        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography176 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography177 }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.bibliography178 }}
        </div> -->

      
      </div>
        <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
